import { DonationCategoriesData } from './../donationCategories.data';
import { ServicesData } from 'src/app/services/services.data';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DonationCategory } from './donationCategory';

@Component({
  selector: 'donationCategory-edit',
  templateUrl: './donationCategory-edit.tmpl.html'
})

export class DonationCategoryEdit implements OnInit {

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public donationCategoriesData: DonationCategoriesData,
    private formBuilder: FormBuilder,
    public servicesData: ServicesData,

  ) {
  }
  subject: number;
  commitmentReasons: any[];
  donationCategory: DonationCategory;
  id: number;
  donationCategoryForm: FormGroup;

  public load(): void {
    if (this.id > 0) {
      this.donationCategoriesData.getEdit(this.id || 0)
        .subscribe((c: any) => {
          this.donationCategory = c;
          this.donationCategoryForm.patchValue(c);
        });
    }
    else {
      this.donationCategoriesData.getAdd()
        .subscribe((c: any) => {
          this.donationCategory = c;
          this.donationCategoryForm.patchValue(c);
        });
    }
  }

  private initForm() {
    this.donationCategoryForm = this.formBuilder.group({
      createBy: [], createDate: [], changeBy: [], changeDate: [],
      donationCategoryID: [this.id || 0, Validators.required],
      title: [, Validators.required],
      openDate: [, Validators.required],
      keyNumber: [],
      currency: [, Validators.required],
      il_TermID: [, Validators.required],
      usa_TermID: [, Validators.required],
      il_ReceiptLetterSettingID: [],
      usa_ReceiptLetterSettingID: [],
      commitmentSubject: [],
      commitmentReasonID: [],
      designation: [],
      isIncludeRecord: [, Validators.required],
    });

        this.getCommitmentReasons()
  }


    public selectSubject(e: any) {
        if (e && e.target) {
          this.subject = +e.target.value;
            this.getCommitmentReasons();
        }
    }

    getCommitmentReasons() {
        let cs = this.donationCategoryForm.controls['commitmentSubject'].value;
        this.servicesData.getList(`CommitmentReasons/${cs}`)
            .subscribe(
                (c: any) => {
                    this.commitmentReasons = c;
                },
                (x) => {
                    //console.log("xxxxxxxx", x);
                });
    }

  ngOnInit() {
    this.activatedRoute.params.forEach((params: Params) => {
      this.id = +params['donationCategoryID'];
    });
    this.initForm();
    this.load();
  }
}



